// Shared HR constants
export const NIVO_OBRAZOVANJA = [
  'Bez obrazovanja',
  'Nepotpuna osnovna škola',
  'Osnovna škola',
  'Srednja škola - trogodišnja',
  'Srednja škola - četvorogodišnja',
  'Gimnazija',
  'Viša škola',
  'Visoka škola - Bachelor',
  'Visoka škola - Master',
  'Doktorat',
];

// Crnogorske opštine (sortirano alfabetski)
export const OPSTINE_CRNE_GORE = [
  'Andrijevica', 'Bar', 'Berane', 'Bijelo Polje', 'Budva', 'Cetinje',
  'Danilovgrad', 'Gusinje', 'Herceg Novi', 'Kolašin', 'Kotor', 'Mojkovac',
  'Nikšić', 'Petnjica', 'Plav', 'Pljevlja', 'Plužine', 'Podgorica',
  'Rožaje', 'Šavnik', 'Tivat', 'Tuzi', 'Ulcinj', 'Zeta', 'Žabljak',
];
